/* Atelier MFK — brouillon accueil (trame Manufacture) */
(function () {
  'use strict';
  document.documentElement.classList.add('mfkm-js');
  document.body && document.body.classList.add('mfkm-on');

  /* ---------- Header: overlay -> solid on scroll ---------- */
  function initHeader() {
    var hd = document.querySelector('.mfkm-hd');
    if (!hd) return;
    var overlay = hd.classList.contains('is-overlay');
    function onScroll() {
      if (!overlay) return;
      var solid = window.scrollY > 40 || hd.classList.contains('is-menu-open');
      hd.classList.toggle('is-solid', solid);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Mega menus (desktop hover + keyboard) */
    var items = hd.querySelectorAll('.mfkm-nav__item.has-mega');
    var closeTimer;
    function closeAll(except) {
      items.forEach(function (it) { if (it !== except) { it.classList.remove('is-open'); var b = it.querySelector('.mfkm-nav__link'); b && b.setAttribute('aria-expanded', 'false'); } });
      if (!except) { hd.classList.remove('is-menu-open'); onScroll(); }
    }
    items.forEach(function (it) {
      var link = it.querySelector('.mfkm-nav__link');
      function open() {
        clearTimeout(closeTimer);
        closeAll(it);
        it.classList.add('is-open');
        link.setAttribute('aria-expanded', 'true');
        hd.classList.add('is-menu-open', 'is-solid');
      }
      it.addEventListener('mouseenter', open);
      it.addEventListener('mouseleave', function () { closeTimer = setTimeout(function () { closeAll(); }, 160); });
      it.addEventListener('focusin', open);
      link.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); link.focus(); } });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    hd.addEventListener('focusout', function (e) { if (!hd.contains(e.relatedTarget)) closeAll(); });

    /* Mobile drawer */
    var drawer = document.querySelector('.mfkm-drawer');
    if (drawer) {
      var openBtn = hd.querySelector('.mfkm-burger');
      function setDrawer(state) {
        drawer.classList.toggle('is-open', state);
        document.documentElement.style.overflow = state ? 'hidden' : '';
        openBtn && openBtn.setAttribute('aria-expanded', state ? 'true' : 'false');
      }
      openBtn && openBtn.addEventListener('click', function () { setDrawer(true); });
      drawer.querySelectorAll('[data-mfkm-close]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
      drawer.querySelectorAll('.mfkm-drawer__nav > li > button').forEach(function (b) {
        b.addEventListener('click', function () {
          var li = b.parentElement; var st = !li.classList.contains('is-open');
          li.classList.toggle('is-open', st); b.setAttribute('aria-expanded', st ? 'true' : 'false');
        });
      });
    }
  }

  /* ---------- Hero vertical slider ---------- */
  function initHero(root) {
    var slides = root.querySelectorAll('.mfkm-hero__slide');
    var dots = root.querySelectorAll('.mfkm-hero__dots button');
    if (slides.length < 2) { slides[0] && slides[0].classList.add('is-active'); return; }
    var i = 0, timer, delay = parseInt(root.getAttribute('data-delay') || '6000', 10);
    function go(n) {
      if (n === i) return;
      var prev = slides[i];
      prev.classList.remove('is-active'); prev.classList.add('is-leaving');
      setTimeout(function () { prev.classList.remove('is-leaving'); }, 1200);
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      restart();
    }
    function restart() { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, delay); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    var y0 = null, x0 = null;
    root.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (y0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) go(dx < 0 ? i + 1 : i - 1);
      y0 = x0 = null;
    });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    slides[0].classList.add('is-active');
    restart();
  }

  /* ---------- Product carousels ---------- */
  function initCarousel(root) {
    var track = root.querySelector('.mfkm-track');
    if (!track) return;
    var bar = root.querySelector('.mfkm-progress span');
    var prev = root.querySelector('[data-mfkm-prev]');
    var next = root.querySelector('[data-mfkm-next]');
    function update() {
      if (!bar) return;
      var max = track.scrollWidth - track.clientWidth;
      var ratio = track.clientWidth / track.scrollWidth;
      var w = Math.max(ratio * 100, 8);
      bar.style.width = w + '%';
      bar.style.left = (max > 0 ? (track.scrollLeft / max) * (100 - w) : 0) + '%';
    }
    function step(dir) {
      var card = track.querySelector('.mfkm-card');
      var w = card ? card.getBoundingClientRect().width + 6 : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
    }
    prev && prev.addEventListener('click', function () { step(-1); });
    next && next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    /* mouse drag */
    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('mousedown', function (e) { down = true; moved = false; sx = e.pageX; sl = track.scrollLeft; });
    window.addEventListener('mouseup', function () { if (down) { down = false; setTimeout(function () { track.classList.remove('is-drag'); }, 0); } });
    track.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - sx;
      if (Math.abs(dx) > 5) { moved = true; track.classList.add('is-drag'); }
      if (moved) { e.preventDefault(); track.scrollLeft = sl - dx; }
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.mfkm-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function boot() {
    document.body.classList.add('mfkm-on');
    initHeader();
    document.querySelectorAll('.mfkm-hero').forEach(initHero);
    document.querySelectorAll('.mfkm-pc').forEach(initCarousel);
    initReveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.mfkm-hero').forEach(initHero);
    e.target.querySelectorAll('.mfkm-pc').forEach(initCarousel);
    e.target.querySelectorAll('.mfkm-reveal').forEach(function (el) { el.classList.add('is-in'); });
    if (e.target.querySelector('.mfkm-hd')) initHeader();
  });
})();
